import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { UserMenu } from '@/components/organisms/UserMenu';
import { LoginButton } from '@/components/molecules/LoginButton';
import { BackButton } from '@/components/molecules/BackButton';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

export interface PageHeaderProps {
  title: string;
  showBackButton?: boolean;
  variant?: 'default' | 'landing';
  rightActions?: ReactNode;
  onLogoClick?: () => void;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  showBackButton = false,
  variant = 'default',
  rightActions,
  onLogoClick,
  className,
}) => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const isLanding = variant === 'landing';

  const handleLogoClick = () => {
    if (onLogoClick) {
      onLogoClick();
    } else {
      navigate('/');
    }
  };

  return (
    <header
      className={cn(
        'page-header-component sticky top-0 z-50 w-full border-b border-border bg-background/80 backdrop-blur-md',
        className
      )}
    >
      <div
        className={cn(
          'flex items-center justify-between',
          isLanding
            ? 'whitespace-nowrap px-4 py-3 max-w-[1200px] mx-auto w-full'
            : 'max-w-[1200px] mx-auto px-4 py-4'
        )}
      >
        <div className="flex items-center gap-4">
          {showBackButton && !isLanding && (
            <BackButton onClick={() => navigate('/')} />
          )}
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={handleLogoClick}
          >
            {title === 'tuval.space' && (
              <img
                src="/logo.svg"
                alt="tuval.space logo"
                className="size-8"
              />
            )}
            <h1
              className={cn(
                'font-bold leading-tight tracking-tight',
                isLanding ? 'text-lg' : 'text-2xl'
              )}
            >
              {title}
            </h1>
          </div>
        </div>

        <div className="flex items-center gap-4">
          {rightActions}
          {!authLoading && !user && <LoginButton />}
          {!authLoading && user && <UserMenu />}
        </div>
      </div>
    </header>
  );
};

